import { Button } from '@coop/components';
import classNames from 'classnames';
import { useId } from 'react';

import { useCncFlyInState } from '../../../common/hooks/useCncFlyInState';
import { useAppSelector } from '../../../common/hooks/useThunkDispatch';
import { cartSelectors } from '../../../common/selectors/cartSelectors';
import { storeSelectors } from '../../../common/selectors/storeSelectors';
import tracking from '../../../common/tracking/tracking';
import styles from './NoticeRibbonDefaultStore.module.scss';

interface NoticeRibbonDefaultStoreProps {
    className?: string;
}

const NoticeRibbonDefaultStore = (props: NoticeRibbonDefaultStoreProps) => {
    const hasActiveStoreSelection = useAppSelector(storeSelectors.hasActiveStoreSelection);
    const postalCode = useAppSelector(cartSelectors.postalCode);
    const labelId = useId();
    const actionId = useId();

    const { initCnc } = useCncFlyInState();

    const openCnc = () => {
        tracking.cnc.openFrom.noticeRibbonDefaultStore(!!postalCode);
        initCnc();
    };

    if (hasActiveStoreSelection) {
        return null;
    }

    return (
        <div className={classNames(styles.Container, props.className)}>
            <div className={styles.Info} id={labelId}>
                <div>Sortiment visas för</div>
                <strong>Hemleverans i Stockholm</strong>
            </div>
            <Button
                theme="primary"
                size="small"
                onClick={openCnc}
                aria-labelledby={`${labelId} ${actionId}`}
                aria-haspopup="dialog"
                className={styles.Button}
            >
                <span id={actionId}>Ändra</span>
            </Button>
        </div>
    );
};

export default NoticeRibbonDefaultStore;
